export default "__VITE_ASSET__C4uvl0H4__"